export default "__VITE_ASSET__43njHY8F__"